<template>
  <v-container>
    <!-- 表单标题  -->
    <p style="font-size: 18px; font-weight: 700; color: rgb(50,134,218); height: 10px;" class="ml-4 mt-2">
      新增设备信息
      <v-icon></v-icon>
    </p>
    <v-icon></v-icon>
    <span class="ml-4" style="color:rgb(132, 132, 132); font-size: 12px;">根据消防点检情况进行填写</span>

    <div>
      <!-- 填报表单 -->
      <v-form ref="form" v-model="isValid">
        <v-card-text>
          <v-row>
            <!-- 设备编号 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备编号 <p
                  style="color: red; display: inline-block;"> *</p></v-text-subtitle>
              <v-text-field v-model="formData.device_id" label="请输入设备编号" :rules="requiredRules" required
                hint="请输入设备编号"></v-text-field>
            </v-col>
            <!-- 设备类型 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备类型 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-select dense v-model="formData.device_type" :items="deviceOptions" label="请选择设备类型"
                :rules="requiredRules" required hint="请选择设备类型"></v-select>
            </v-col>

            <!-- 设备状态 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备状态 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-select dense v-model="formData.device_status" :items="deviceResultOptions" label="请选择设备类型"
                :rules="requiredRules" required hint="请选择设备类型"></v-select>
            </v-col>

            <!-- 设备附件图片 -->
            <v-col cols="12" sm="6" md="4" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">上传图片 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-file-input v-model="device_attachment" label="上传现场图片" accept="image/*" required
                hint="支持上传图片、PDF、Word文档" @change="uploadImage(device_attachment)" :rules="[v => !!v || '请上传一张图片']">
                <!-- @update:model-value="handleFileInput" -->
              </v-file-input>
              <v-img v-if="imageUrl" :src="imageUrl" aspect-ratio="1" class="mt-4" max-width="200"></v-img>
            </v-col>

            <!-- 设备点检反馈结果 -->
            <!-- <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px; height: 124px;">
              <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px; padding: 0;">设备状态 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-radio-group v-model="formData.deviceResult" label="" :rules="requiredRules" required row
                class="d-flex align-center">
                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;" label="正常"
                  value="normal"></v-radio>
                <v-radio style="border:1px rgb(188,188,189) solid; border-radius: 30px; width: 45%;" label="异常"
                  value="abnormal"></v-radio>
              </v-radio-group>
            </v-col> -->

            <!-- 设备描述 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">详情描述 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-textarea v-model="formData.device_description" label="设备描述" :rules="requiredRules" required
                hint="请输入设备描述"></v-textarea>
            </v-col>

            <!-- 使用车间 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">使用车间 <p
                  style="color: red; display: inline-block;"> *</p></v-text-subtitle>
              <v-text-field v-model="formData.device_buliding" label="请输入设备楼栋位置" :rules="requiredRules" required
                hint="请输入设备楼栋位置"></v-text-field>
            </v-col>

            <!-- 安装位置 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">安装位置 <p
                  style="color: red; display: inline-block;"> *</p></v-text-subtitle>
              <v-text-field v-model="formData.device_floor" label="请输入设备楼层位置" :rules="requiredRules" required
                hint="请输入设备楼层位置"></v-text-field>
            </v-col>

            <!-- 设备启用日期 -->
            <v-col cols="12" class="mt-1" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;">
              <v-text-subtitle style="color:rgb(0, 0, 0); font-size: 15px;">设备启用日期 <p
                  style="color: red; display: inline-block;">*</p></v-text-subtitle>
              <v-menu style="text-align: center;" :rounded="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="formData.device_date" label="设备启用日期" readonly v-bind="attrs" v-on="on"
                    :rules="requiredRules" required class="d-flex align-center">
                  </v-text-field>
                </template>
                <!-- 日历表单选择卡 -->
                <v-date-picker v-model="formData.device_date" :min-date="new Date().toISOString().split('T')[0]"
                  :max-date="new Date(Date.now() + 5 * 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]" no-title
                  scrollable locale="zh-cn" style="text-align: center; justify-content: center; align-items: center;"
                  width="332" format="yyyy-MM-dd HH:mm:ss">
                </v-date-picker>
              </v-menu>
            </v-col>


            <!-- 设备负责人 -->
            <v-col cols="12" style="border: 1px rgb(188,188,189) solid; border-radius: 3px;" class="mt-1">
              <v-text-subtitle class="" style="color:rgb(0, 0, 0); font-size: 15px;">设备负责人 <p
                  style="color: red; display: inline-block;"> *</p></v-text-subtitle>
              <v-text-field v-model="formData.device_person" label="请输入设备负责人" :rules="requiredRules" required
                hint="请输入设备负责人"></v-text-field>
            </v-col>

          </v-row>
        </v-card-text>
        <!-- 卡片活动计较填报数据到后端进行处理/重置编写的表单数据内容进行重新填写 -->
        <v-card-actions class="d-flex justify-space-around">
          <!-- <v-spacer></v-spacer>   -->
          <v-btn color="success" dark @click="resetForm">重置</v-btn>
          <v-btn color="blue darken-1" dark @click="submitForm">提交</v-btn>

        </v-card-actions>
      </v-form>
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'device',
  data() {
    return {
      isValid: false,                          //  表单状态 
      formData: {
        device_id: '',                         //  设备编号
        device_type: '',                       //  设备类型
        device_status: '',                     //  设备状态
        device_attachment: null,               //  设备图片 
        device_description: '',                //  设备描述
        device_buliding: '',                   //  设备楼宇
        device_floor: '',                      //  设备楼层
        device_date: '',                       //  设备使用期限(时间)
        device_person: '',                     //  负责人
      },
      imageUrl: null,                          //  接收返回的图片地址渲染img

      deviceOptions: ['灭火器', '消防栓', '烟感设备', '手报设备', '防火卷帘', '应急设备', '排烟设备'],
      deviceResultOptions: ['正常运行', '维修中', '备用', '带病运行', '报废'],
      requiredRules: [v => !!v || '该字段是必填项']
    }
  },
  // 页面加载初始化页面内内容页面
  mounted() {

  },


  methods: {
    // 提交保存数据表数据记录    
    async submitForm() {
      console.log('填报的数据信息', this.formData);
      if (this.isValid) {
        try {
          await this.submitFormData();
          this.showSucceSnackbar("填报成功。");
        } catch (error) {

        }

      }
    },

    async submitFormData() {
      try {
        // 保持和后端接口实体类参数名对照和数据库数据表字段一致
        const textData = {
          device_id: this.formData.device_id,                                 //设备编号
          device_type: this.formData.device_type,                             //设备类型
          device_status: this.formData.device_status,                         //设备状态
          device_attachment: this.imageUrl,                                   //设备图片
          device_description: this.formData.device_description,               //设备描述
          device_buliding: this.formData.device_buliding,                     //设备使用区域
          device_floor: this.formData.device_floor,                           //设备安装位置
          device_date: this.formData.device_date,                              //设备启用期限
          device_person: this.formData.device_person,                          //设备负责人
        };
        console.log('拼接表单字段内容', textData);
        const jsonData = JSON.stringify(textData);

        console.log(jsonData);
        const response = await fetch('http://192.168.3.3:18081/device/addDevice', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: jsonData,
        });
        if (!response.ok) {
          throw new Error("提交失败!");
        }
        console.log("提交成功!");
        this.$router.push("/logoDevice");


      } catch (error) {
        console.error('提交过程中发生错误：', error);
        this.showErrorSnackbar('提交失败，请检查网络或数据格式');
      }
    },

    // 上传图片
    async uploadImage(device_attachment) {
      const formData = new FormData();
      const file = device_attachment;
      console.log("上传图片获取的地址", file)
      if (file) {
        formData.append('device_attachment', file);
      }
      try {
        const response = await fetch('http://192.168.3.3:18081/device/files/upload/image', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          throw new Error('图片上传失败!');
        }

        const data = await response.json();
        const userData = data.data;
        this.imageUrl = userData.device_attachment;
        console.log("图片上传成功,地址:", this.imageUrl);
        return this.imageUrl;
      } catch (error) {
        console.error("图片上传失败!", error);
        throw error;
      }
    },

    // 上传表单文本
    // async submiTextData(textData) {
    //   const jsonData = JSON.stringify(textData);
    //   console.log(jsonData);
    //   const response = await fetch('http://127.0.0.1:18080/device/addDevice', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: jsonData,
    //   });
    //   console.log(response);
    // },

    resetForm() {
      // 根据填报表单ref标签进行重置表单数据
      // this.$refs.form.reset()

      this.formData = {
        device_id: '',                         //  设备编号
        device_type: '',                       //  设备类型
        device_status: '',                     //  设备状态
        device_attachment: null,               //  设备图片 
        device_description: '',                //  设备描述
        device_buliding: '',                   //  设备楼宇
        device_floor: '',                      //  设备楼层
        device_date: '',                       //  设备使用期限(时间)
        device_person: '',                     //  负责人  
      },
        this.imageUrl = null;                  //  前端渲染的图片Url
    },

    showErrorSnackbar(message) {
      this.$snackbar = {
        isShowing: true,
        message: message,
        coSlor: 'error',
        timeout: 5000
      }
    },

    // 保存页面上传的图片
    // handleFileInput(file) {
    //   if (file) {
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //       this.imageUrl = e.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   } else {
    //     this.imageUrl = null;
    //   }
    // }
  }
}
</script>